import '#/PublicPath';

import { App } from './app';
import { renderSsrClient } from './rendering/client/renderSsrClient';
import { getRouteObjects } from './routing/route-objects';

void renderSsrClient({
  Component: App,
  routeObjects: getRouteObjects(),
});
